import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";

type ResetPasswordCredentialsDTO = {
    email: string;
    newPassword:string;
    confirmPassword:string;
};
export const resetpassword = (data: ResetPasswordCredentialsDTO): Promise<ApiError> => {
    return axios.put("/student/resetPassword", data);
};
